"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIs = require("react-is");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ListItem(props) {
  var component = props.component,
      className = props.className,
      children = props.children,
      selectable = props.selectable,
      borderless = props.borderless,
      rest = _objectWithoutProperties(props, ["component", "className", "children", "selectable", "borderless"]);

  var InjectedComponent = component;
  var computedClassName = (0, _classnames.default)('p-2 text-sm', {
    'cursor-pointer': selectable,
    'border -mb-px': !borderless,
    'border-b': borderless
  }, className);
  return _react.default.createElement(InjectedComponent, _extends({
    className: computedClassName
  }, rest), children);
}

ListItem.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  component: function component(props, propName, componentName) {
    if (props[propName] && !(0, _reactIs.isValidElementType)(props[propName])) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "': the prop is not a valid React component"));
    }
  },
  selectable: _propTypes.default.bool,
  borderless: _propTypes.default.bool
};
ListItem.defaultProps = {
  className: '',
  component: 'div',
  selectable: false,
  borderless: false
};

var _default = _react.default.memo(ListItem);

exports.default = _default;